/* ---- Be Neo MindMag — caixa de compra da pagina SO de assinatura (sub2) ----
   Fork de `brainmag-sub.js`, feito em 24/09/2026. A sub segue no ar com o
   arquivo original, intocado: as duas nunca renderizam juntas.

   O que muda em relacao a sub:
     - NAO ha checkbox. Com selling plan na variante, o botao principal sempre
       vende a assinatura.
     - o RISCADO do card e do botao e o preco de COMPRA UNICA (54.99 / 109.99 /
       164.99), nao o compare_at do avulso. Pedido dele em 24/09: o riscado
       mostra o beneficio da recorrencia. O "Save %" e o da assinatura sobre o
       avulso (27% nos tres packs).
     - compra unica e o link "BUY ONCE - NO SAVINGS $X" abaixo do botao: vai
       ao checkout com a variante avulsa, sem plano.
     - o item leva `_pagina: sub2` (propriedade oculta, nao aparece no
       checkout): e o que separa, na Shopify, os pedidos desta pagina dos da
       sub, que vendem os mesmos dois produtos.
     - sem selling plan (o app ainda nao criou os planos, ou os apagou), a
       pagina vende so compra unica, com a ancora do avulso, e o link some.

   Galeria e contador sao copia literal do A — `tests/paridade-sub2.test.js`
   trava isso.
   -------------------------------------------------------------------------- */
(function () {
  var D = {};                    /* qty -> assinatura {variantId, price, ship, avail, plan} */
  var O = {};                    /* qty -> compra unica {variantId, once, ship, avail} */
  var QTYS = [];
  var qty = 0;
  var sub = true;                /* sem caixa: vira false so se a loja nao tiver plano */
  var PAGINA = 'sub2';           /* vai no item como `_pagina` */

  /* Na moeda do visitante (Markets): '$' nos EUA, '£' no Reino Unido. O valor
     ja vem convertido pelo Liquid; aqui so troca o simbolo. */
  function usd(n) {
    var c = window.Shopify && Shopify.currency && Shopify.currency.active;
    return ({ GBP: '\u00a3', EUR: '\u20ac' }[c] || '$') + n.toFixed(2);
  }

  function lerJson(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function read() {
    var a = lerJson('lp-offer-data');
    if (!a || !a.items || !a.items.length) return false;
    a.items.forEach(function (it) {
      if (!it.qty) return;
      D[it.qty] = {
        variantId: it.variantId,
        price: (it.plan && it.plan.price != null ? it.plan.price : it.oncePrice) / 100,
        compare: it.comparePrice ? it.comparePrice / 100 : null,
        ship: parseFloat(it.ship) || 0,
        avail: it.available !== false,
        plan: it.plan || null
      };
      QTYS.push(it.qty);
    });
    var b = lerJson('lp-once-data');
    if (b && b.items) {
      b.items.forEach(function (it) {
        if (!it.qty) return;
        O[it.qty] = {
          variantId: it.variantId,
          once: it.oncePrice / 100,
          compare: it.comparePrice ? it.comparePrice / 100 : null,
          ship: parseFloat(it.ship) || 0,
          avail: it.available !== false
        };
      });
    }
    return QTYS.length > 0;
  }

  function temPlano() {
    return QTYS.some(function (q) { return D[q] && D[q].plan && D[q].plan.id; });
  }
  /* Modo assinatura de verdade: ha plano na loja E a variante tem plano. */
  function modoSub() { return sub && !!(D[qty] && D[qty].plan && D[qty].plan.id); }
  /* Preco avulso da quantidade. Sem o produto de compra unica na pagina, cai no
     proprio preco da assinatura — a pagina nunca fica sem preco. */
  function avulso(q) { return O[q] ? O[q].once : (D[q] ? D[q].price : 0); }
  /* Assinando? Entao o card e do produto de assinatura; senao, do avulso. */
  function subDe(q) { return sub && D[q] && D[q].plan; }
  /* O card mostra o preco que se paga: o de assinante quando ha plano. */
  function precoCard(q) { return precoPago(q); }
  function precoPago(q) { return subDe(q) ? D[q].price : avulso(q); }
  /* O RISCADO, assinando, e o preco de COMPRA UNICA da mesma quantidade — e
     o beneficio da recorrencia ficando visivel no card, como no modelo que ele
     mandou. Sem plano (pagina vendendo avulso), cai no compare_at do avulso,
     para o card nunca ficar sem ancora. Uma ancora por card, e o mesmo numero
     no botao. */
  function riscadoDe(q) {
    if (subDe(q) && O[q]) return O[q].once;
    return ((O[q] && O[q].compare) || (D[q] && D[q].compare) || 0);
  }
  function ativo(q) { return (sub && D[q] && D[q].plan) ? D[q] : (O[q] || D[q]); }

  function pickDefault() {
    var flagged = document.querySelector('[data-mm-qty][data-mm-default]');
    if (flagged && D[+flagged.dataset.mmQty]) return +flagged.dataset.mmQty;
    return QTYS[Math.floor(QTYS.length / 2)] || QTYS[0];
  }

  /* A cadencia vem da loja, nunca daqui. Dois formatos chegam no `every`:
       - o Kaching publica um JSON  {"delivery":{"interval":"MONTH","frequency":3},...}
       - outros apps publicam texto  "3 months"
     Os dois caem aqui. Sem casar nenhum, devolve null e a data some do texto —
     nunca imprime o cru na tela. Medido em 17/09/2026, com os planos reais. */
  function cadencia(plan) {
    if (!plan) return null;
    var bruto = String(plan.every == null ? '' : plan.every);
    if (bruto.charAt(0) === '{') {
      try {
        var j = JSON.parse(bruto), d = j && (j.delivery || j.billing);
        if (d && d.interval) return { n: d.frequency || 1, unidade: String(d.interval).toLowerCase() };
      } catch (e) { /* cai no texto */ }
    }
    var m = /(\d+)\s*(day|week|month|year)/i.exec(bruto) ||
            /(\d+)\s*(day|week|month|year)/i.exec(String(plan.name || ''));
    if (m) return { n: parseInt(m[1], 10), unidade: m[2].toLowerCase() };
    var um = /every\s+(day|week|month|year)/i.exec(String(plan.name || '') + ' ' + bruto);
    if (um) return { n: 1, unidade: um[1].toLowerCase() };
    return null;
  }

  function textoCadencia(plan) {
    var c = cadencia(plan);
    if (c) return c.n === 1 ? 'every ' + c.unidade : 'every ' + c.n + ' ' + c.unidade + 's';
    /* Ultimo recurso: o NOME do plano, que e texto de gente ("Delivery: every 3
       months"). O `every` cru nunca vai para a tela — no Kaching ele e um JSON. */
    return plan && plan.name ? String(plan.name).replace(/^\s*delivery\s*:\s*/i, '') : '';
  }

  function render() {
    var d = ativo(qty);
    if (!d) return;
    var emSub = modoSub();

    document.querySelectorAll('[data-mm-qty]').forEach(function (card) {
      var q = +card.dataset.mmQty, k = ativo(q);
      card.setAttribute('aria-selected', q === qty);
      if (!k) { card.hidden = true; return; }

      var preco = precoCard(q), cheio = riscadoDe(q);

      var price = card.querySelector('[data-mm-price]');
      if (price) price.textContent = usd(preco);

      var was = card.querySelector('[data-mm-was]');
      var save = card.querySelector('[data-mm-save]');
      var temEconomia = cheio > preco;
      if (was) {
        if (temEconomia) { was.textContent = usd(cheio); was.hidden = false; }
        else { was.hidden = true; }
      }
      if (save) {
        if (temEconomia) {
          save.textContent = 'Save ' + Math.round((1 - preco / cheio) * 100) + '%';
          save.hidden = false;
        } else { save.hidden = true; }
      }

      var per = card.querySelector('[data-mm-per]');
      if (per) per.textContent = usd(preco / q) + ' a bottle';
    });

    var info = document.getElementById('mm-subinfo');
    if (info) {
      info.hidden = !emSub;
      var cad = info.querySelector('[data-mm-cadence]');
      if (cad) {
        var t = emSub ? textoCadencia(D[qty].plan) : '';
        cad.textContent = t ? 'Refilled ' + t : '';
      }
      /* O link da compra unica: preco avulso da MESMA quantidade do card
         selecionado. "No savings" e verdade porque e o proprio riscado. */
      var once = document.getElementById('mm-once');
      if (once) {
        var o = O[qty];
        once.hidden = !o || !emSub;
        var op = once.querySelector('[data-mm-once-price]');
        if (op) op.textContent = o ? usd(o.once) : '';
        once.disabled = !(o && o.avail);
      }
    }

    var btn = document.getElementById('mm-buy');
    if (btn) {
      var total = precoPago(qty);
      /* O riscado do botao e a MESMA ancora do card, assinando ou nao. Uma
         ancora por pagina. */
      var cheioBtn = riscadoDe(qty);
      btn.innerHTML = '';
      btn.appendChild(document.createTextNode(
        /* 'ADD TO CART' nos dois modos, a pedido dele em 24/09 (antes era
           'SUBSCRIBE & SAVE' assinando). */
        'ADD TO CART \u00b7 ' + usd(total)
      ));
      if (cheioBtn > total) {
        var s = document.createElement('span');
        s.className = 'was';
        s.textContent = usd(cheioBtn);
        btn.appendChild(s);
      }
      btn.disabled = !d.avail;
    }

    var note = document.getElementById('mm-ship');
    if (note) {
      note.innerHTML = d.ship > 0
        ? 'Shipping ' + usd(d.ship) + ' \u2014 <b>free on 3 and 5 bottles</b>'
        : '<b>Free US shipping</b> on this bundle';
    }

    /* O paragrafo de termos saiu em 24/09, a pedido dele. Os termos completos
       estao na politica de assinatura, linkada no check "Cancel anytime". */
  }

  function say(msg) {
    var el = document.getElementById('mm-err');
    if (el) { el.textContent = msg; el.hidden = false; }
  }

  /* Propriedades de linha: e o que o comprador ve no checkout, no e-mail e no
     pedido do admin. Mesma regra do A — todo numero e calculado, nunca escrito.
     No modo assinatura entra tambem a cadencia, porque e o que a pessoa precisa
     reconhecer quando a proxima cobranca chegar. */
  function oferta(avulsa) {
    var props = {};
    var card = document.querySelector('[data-mm-qty="' + qty + '"]');
    var titulo = card && card.querySelector('.b-title');
    var emSub = modoSub() && !avulsa;
    var preco = avulsa ? avulso(qty) : precoPago(qty);

    if (titulo && qty > 1) {
      props['Your offer'] = titulo.textContent.trim() + ' \u2014 ' + qty + ' bottles';
    }
    props['Price per bottle'] = usd(preco / qty);
    /* Sem "You save" no item, nos dois modos: pedido do Matheus em 18/09 — a
       linha no resumo do checkout nao ajudava a oferta. Ninguem le essa
       propriedade (nem teste, nem notificacao, nem AfterSell). */
    if (emSub) {
      props['Subscription'] = 'Delivered ' + textoCadencia(D[qty].plan) + ' \u2014 cancel anytime';
    }
    /* Oculta (o "_" esconde no checkout e no e-mail): so para separar os
       pedidos desta pagina dos da sub na Shopify. */
    props['_pagina'] = PAGINA;
    return props;
  }

  function adicionar(items) {
    var cs = typeof window !== 'undefined' && window.carrinhoSubstitui;
    if (cs) return cs.adicionar(items);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.ok ? r.json() : r.json().then(function (e) { throw e; }); });
  }

  /* `avulsa` = veio do link BUY ONCE: variante do produto de compra unica,
     sem plano. Senao, a do botao principal (assinatura, quando ha plano). */
  function buy(ev, avulsa) {
    if (ev) ev.preventDefault();
    var d = avulsa ? O[qty] : ativo(qty);
    if (!d) return say('Pick a bundle');

    var alvo = document.getElementById(avulsa ? 'mm-once' : 'mm-buy');
    if (alvo) alvo.setAttribute('aria-busy', 'true');

    var item = { id: d.variantId, quantity: 1, properties: oferta(avulsa) };
    if (!avulsa && modoSub()) item.selling_plan = D[qty].plan.id;

    adicionar([item])
      .then(function () { window.location.href = '/checkout'; })
      .catch(function (e) {
        if (alvo) alvo.removeAttribute('aria-busy');
        console.error('[brainmag-sub2] /cart/add.js falhou', e);
        say((e && e.description) || 'Could not add to cart \u2014 try again');
      });
  }

  /* ---- RedTrack: viewcontent --------------------------------------------
     O `events.js` do RedTrack so manda viewcontent quando acha
     `<form action="/cart/add">` na pagina ou quando o ULTIMO pedaco da URL e
     handle de produto (ele busca `/products/<pedaco>.json`). A sub e a PDP B
     passam por coincidencia de nome (`brain-magnesium-sub` e `brain-magnesium`
     sao produtos); aqui `/products/brain-magnesium-sub2.json` da 404 e o
     evento nao saia. Medido em 24/09/2026.

     Form nao serve: e onde o widget do Kaching se injeta. Entao a pagina manda
     o MESMO que o events.js mandaria: GET no /postback com type=viewcontent e
     eventid = clickid (o RedTrack recusa o repetido, entao disparo duplo nao
     conta duas vezes), e o `__clickid` gravado no carrinho. O host vem da tag
     do proprio events.js, nunca escrito aqui.
     -------------------------------------------------------------------------- */
  function redtrackViewContent(tentativa) {
    var tag = document.querySelector('script[src*="/events.js"]');
    if (!tag || !tag.src) return;
    var host = tag.src.split('/').slice(0, 3).join('/');
    var id = null;
    var m = /(?:^|; )rtkclickid-store=([^;]*)/.exec(document.cookie || '');
    if (m) id = decodeURIComponent(m[1]);
    if (!id || id === 'undefined') {
      try { id = window.sessionStorage.getItem('rtkclickid'); } catch (e) { id = null; }
    }
    if (!id || id === 'undefined') {
      /* o clickid chega pelo unilpclick.js, que pode demorar; o events.js
         tenta a cada 1 s. Aqui com teto de 30 s. */
      if ((tentativa || 0) < 30) setTimeout(function () { redtrackViewContent((tentativa || 0) + 1); }, 1000);
      return;
    }
    var x = new XMLHttpRequest();
    x.open('GET', host + '/postback?clickid=' + encodeURIComponent(id) +
      '&type=viewcontent&eventid=' + encodeURIComponent(id));
    x.send();
    var c = new XMLHttpRequest();
    c.open('POST', '/cart/update.js');
    c.setRequestHeader('Content-Type', 'application/json');
    c.send(JSON.stringify({ attributes: { '__clickid': id } }));
  }

  /* ---- Galeria: slides, nao troca de src, para o srcset do beneo-img valer --
     Com 8 imagens (02/09/2026, antes 6) a miniatura sozinha nao da conta: no
     celular a fila rola de lado e as ultimas ficam fora da tela, entao quem so
     olha nem descobre que ha mais imagem. Dai as setas, o contador e o arrasto.
     -------------------------------------------------------------------------- */
  function gallery() {
    var slides = document.querySelectorAll('[data-mm-slide]');
    var thumbs = document.querySelectorAll('[data-mm-thumb]');
    var strip = document.querySelector('.thumbs');
    var count = document.querySelector('[data-mm-count]');
    var prev = document.querySelector('[data-mm-prev]');
    var next = document.querySelector('[data-mm-next]');
    var main = document.querySelector('.gallery-main');
    if (!slides.length) return;

    var at = 0;

    function show(i) {
      at = (i + slides.length) % slides.length;   /* circula nas duas pontas */
      slides.forEach(function (s, n) { s.setAttribute('data-on', n === at ? '1' : '0'); });
      thumbs.forEach(function (t, n) { t.setAttribute('aria-selected', n === at); });
      if (count) count.textContent = (at + 1) + ' / ' + slides.length;

      /* Centraliza a miniatura ativa na fila. So mexe no scroll HORIZONTAL da
         propria fila — scrollIntoView aqui arrastaria a pagina inteira. */
      var t = thumbs[at];
      if (t && strip && strip.scrollWidth > strip.clientWidth + 2) {
        strip.scrollTo({
          left: Math.max(0, t.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2),
          behavior: 'smooth'
        });
      }
    }

    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });
    if (prev) prev.addEventListener('click', function () { show(at - 1); });
    if (next) next.addEventListener('click', function () { show(at + 1); });

    /* Arrastar o dedo na imagem grande. Os 40 px de folga e a comparacao com o
       eixo Y existem para nao roubar o scroll de quem so esta descendo a pagina. */
    if (main) {
      var x0 = null, y0 = 0;
      main.addEventListener('touchstart', function (e) {
        x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
      }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        var dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(at + (dx < 0 ? 1 : -1));
        x0 = null;
      }, { passive: true });
    }

    show(0);
  }

  /* ---- Contagem regressiva do topo ----------------------------------------
     Sessao, nao data: um prazo real que expirasse deixaria a barra em 00:00:00
     no dia seguinte, que e pior do que nao ter barra. Reinicia a cada visita. */
  function timer() {
    var box = document.getElementById('mm-timer');
    if (!box) return;
    var left = (parseInt(box.dataset.minutes, 10) || 10) * 60;
    var h = box.querySelector('[data-t-h]'),
        m = box.querySelector('[data-t-m]'),
        s = box.querySelector('[data-t-s]');
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      if (left <= 0) { left = (parseInt(box.dataset.minutes, 10) || 10) * 60; }
      if (h) h.textContent = pad(Math.floor(left / 3600));
      if (m) m.textContent = pad(Math.floor(left / 60) % 60);
      if (s) s.textContent = pad(left % 60);
      left--;
    }
    tick();
    setInterval(tick, 1000);
  }

  function init() {
    gallery();
    timer();
    redtrackViewContent(0);
    if (!read()) return;
    qty = pickDefault();
    sub = temPlano();
    document.querySelectorAll('[data-mm-qty]').forEach(function (card) {
      card.addEventListener('click', function () { qty = +card.dataset.mmQty; render(); });
    });
    var b = document.getElementById('mm-buy');
    if (b) b.addEventListener('click', function (e) { buy(e, false); });
    var o = document.getElementById('mm-once');
    if (o) o.addEventListener('click', function (e) { buy(e, true); });
    if (typeof window !== 'undefined' && window.addEventListener) {
      window.addEventListener('pageshow', function (e) {
        if (!e.persisted) return;
        if (b) b.removeAttribute('aria-busy');
        if (o) o.removeAttribute('aria-busy');
      });
    }
    render();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
